import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "../../helpers/AsyncFunc";
import {
  user_admin,
  user_sales,
  user_sales_co,
  user_finance,
  user_cs,
  user_marketer,
} from "../../settings/user";
import { siteConfig } from "../../settings";

const DEBUG = siteConfig.DEBUG;

// Route configurations
const routes = {
  // ROUTES FOR ADMIN(user_admin) & CS(user_cs)
  // VISIBLE MENU: Dashboard(All), Community(All), PMC(All), SGC(All), PDC(All), Service(All), VMS(All), Niti News Update(All), Recycling(All), Social(All), Utilities(All)
  admin: [
    {
      path: "",
      component: asyncComponent(() => import("../Page/Dashboard")),
    },
    {
      path: "dashboard",
      component: asyncComponent(() => import("../Page/Dashboard")),
    },
    {
      path: "mapview",
      component: asyncComponent(() => import("../Page/Dashboard/GoogleMap")),
    },
    {
      path: "community",
      component: asyncComponent(() => import("../Page/Community")),
    },
    {
      path: "community/detail",
      component: asyncComponent(() =>
        import("../Page/Community/CommunityDetail")
      ),
    },
    {
      path: "pmc",
      component: asyncComponent(() => import("../Page/PMCs")),
    },
    {
      path: "sgc",
      component: asyncComponent(() => import("../Page/SGC")),
    },
    {
      path: "sgc/detail",
      component: asyncComponent(() => import("../Page/SGC/sgcDetail")),
    },
    {
      path: "pdc",
      component: asyncComponent(() => import("../Page/PDC")),
    },
    {
      path: "pdc/detail",
      component: asyncComponent(() => import("../Page/PDC/pdcDetail")),
    },
    {
      path: "services/transactions",
      component: asyncComponent(() => import("../Page/Services/transactionList")),
    },
    {
      path: "services/activitylog",
      component: asyncComponent(() => import("../Page/Services/activityLogs")),
    },
    {
      path: "recycling",
      component: asyncComponent(() => import("../Page/Recycling")),
    },
    {
      path: "vms",
      component: asyncComponent(() => import("../Page/VMS")),
    },
    {
      path: "newsupdate",
      component: asyncComponent(() => import("../Page/NitiNewsUpdate")),
    },
    {
      path: "newsupdate/form",
      component: asyncComponent(() =>
        import("../Page/NitiNewsUpdate/newsUpdateForm")
      ),
    },
    {
      path: "social",
      component: asyncComponent(() => import("../Page/Social/ReportPost")),
    },
    {
      path: "social/reportposts",
      component: asyncComponent(() => import("../Page/Social/ReportPost")),
    },
    {
      path: "social/reportfakename",
      component: asyncComponent(() => import("../Page/Social/ReportUserFakeName")),
    },
    {
      path: "social/reportspamuser",
      component: asyncComponent(() => import("../Page/Social/ReportUserSpam")),
    },
    {
      path: "social/reportthreatuser",
      component: asyncComponent(() =>
        import("../Page/Social/ReportUserThreat")
      ),
    },
    {
      path: "utilities/changename",
      component: asyncComponent(() => import("../Page/Utilities/ChangeName")),
    },
    {
      path: "utilities/forgotpassword",
      component: asyncComponent(() =>
        import("../Page/Utilities/ForgotPassword")
      ),
    },
    {
      path: "utilities/otp",
      component: asyncComponent(() =>
        import("../Page/Utilities/VerificationOTP")
      ),
    },
    {
      path: "utilities/nitiwebversion",
      component: asyncComponent(() =>
        import("../Page/Utilities/NitiWebVersion")
      ),
    },
    {
      path: "utilities/AndroidAPKList",
      component: asyncComponent(() =>
        import("../Page/Utilities/AndroidAPKList")
      ),
    },
    {
      path: "utilities/guardappfeature",
      component: asyncComponent(() =>
        import("../Page/Utilities/GuardAppFeature")
      ),
    },
    {
      path: "blankPage",
      component: asyncComponent(() => import("../blankPage")),
    },
    {
      path: "authCheck",
      component: asyncComponent(() => import("../AuthCheck")),
    },
    {
      path: "*",
      component: asyncComponent(() => import("../Page/404")),
    },
  ],
  sales: [
    // ROUTES FOR SALES (user_sales) & SALES CO (user_sales_co)
    // VISIBLE MENU: Dashboard(All), Community(Except> Res, Tennat, Committee), PMC(All), SGC(All), PDC(All), VMS(All)
    {
      path: "",
      component: asyncComponent(() => import("../Page/Dashboard")),
    },
    {
      path: "dashboard",
      component: asyncComponent(() => import("../Page/Dashboard")),
    },
    {
      path: "mapview",
      component: asyncComponent(() => import("../Page/Dashboard/GoogleMap")),
    },
    {
      path: "community",
      component: asyncComponent(() => import("../Page/Community")),
    },
    {
      path: "community/detail",
      component: asyncComponent(() =>
        import("../Page/Community/CommunityDetail")
      ),
    },
    {
      path: "pmc",
      component: asyncComponent(() => import("../Page/PMCs")),
    },
    {
      path: "sgc",
      component: asyncComponent(() => import("../Page/SGC")),
    },
    {
      path: "sgc/detail",
      component: asyncComponent(() => import("../Page/SGC/sgcDetail")),
    },
    {
      path: "pdc",
      component: asyncComponent(() => import("../Page/PDC")),
    },
    {
      path: "pdc/detail",
      component: asyncComponent(() => import("../Page/PDC/pdcDetail")),
    },
    {
      path: "vms",
      component: asyncComponent(() => import("../Page/VMS")),
    },
    {
      path: "blankPage",
      component: asyncComponent(() => import("../blankPage")),
    },
    {
      path: "authCheck",
      component: asyncComponent(() => import("../AuthCheck")),
    },
    {
      path: "*",
      component: asyncComponent(() => import("../Page/404")),
    },
  ],
  marketer: [
    // ROUTES FOR FINANCE and MARKETER
    // VISIBLE MENU: Service(All), Niti News Update (All)
    {
      path: "services/transactions",
      component: asyncComponent(() => import("../Page/Services/transactionList")),
    },
    {
      path: "newsupdate",
      component: asyncComponent(() => import("../Page/NitiNewsUpdate")),
    },
    {
      path: "newsupdate/form",
      component: asyncComponent(() =>
        import("../Page/NitiNewsUpdate/newsUpdateForm")
      ),
    },
    {
      path: "blankPage",
      component: asyncComponent(() => import("../blankPage")),
    },
    {
      path: "authCheck",
      component: asyncComponent(() => import("../AuthCheck")),
    },
    {
      path: "*",
      component: asyncComponent(() => import("../Page/404")),
    },
  ],
  default: [
    // ROUTES FOR DEFAULT
    // VISIBLE MENU: NONE
    {
      path: "blankPage",
      component: asyncComponent(() => import("../blankPage")),
    },
    {
      path: "authCheck",
      component: asyncComponent(() => import("../AuthCheck")),
    },
    {
      path: "*",
      component: asyncComponent(() => import("../Page/404")),
    },
  ],
};

// Function to map routes based on user role
const getRoutesForRole = (role) => {
  DEBUG && console.log("role: " + role);
  return routes[role] || routes.default;
};

class AppRouter extends Component {
  render() {
    const { url, style } = this.props;
    const userID = localStorage.getItem("userID");
    // Determine user role
    const userRole =
      user_admin.includes(userID) || user_cs.includes(userID)
        ? "admin"
        : user_sales.includes(userID) || user_sales_co.includes(userID)
        ? "sales"
        : user_finance.includes(userID) || user_marketer.includes(userID)
        ? "marketer"
        : "default"; 

    return (
      <div style={style}>
        <Switch>
          {getRoutesForRole(userRole).map((singleRoute) => {
            const { path, exact, ...otherProps } = singleRoute;
            return (
              <Route
                exact={exact === false ? false : true}
                key={singleRoute.path}
                path={`${url}/${singleRoute.path}`}
                {...otherProps}
              />
            );
          })}
        </Switch>
      </div>
    );
  }
}

export default AppRouter;
